import EventBus from '../utils/eventbus/eventbus.js';


export default EventBus();
